export default __webpack_public_path__ + "static/media/switch-off.ff3154cb.svg";